// Dependencies
import { FC, useRef } from "react";
import * as Yup from "yup";

// Components
import IconInput from "../IconInput";
import FormItem from "~/components/Layout/LayoutForm/FormItem";
import Button, { WarningButton } from "~/components/Common/Button";
import { Form, Formik } from "formik";
import { If } from "jsx-control-statements";

// types
import { DefaultCategory } from "~/enums";

// Styles
import {
  StyledInfoLabel,
  StyledInfoDetail,
  StyledInfoWrapper,
  StyledInfoContent,
} from "~/components/Layout/LayoutInfo";
import {
  StyledUnsaved,
  StyledFormInput,
  StyledFormAction,
} from "~/components/Layout/LayoutForm/Form.styled";
import { handleCancelForm } from "~/utils";

interface CategoryEditProps {
  initialData: { id: string; name: string } | undefined;
  onSubmit: Function;
  onCancel: Function;
}

const CategoryEdit: FC<CategoryEditProps> = ({
  initialData,
  onSubmit,
  onCancel,
}) => {
  const formRef = useRef<any>(null);

  // Methods
  const handleSubmitForm = (data: { name: string; iconId: string }) => {
    onSubmit(data);
  };

  return (
    <StyledInfoWrapper>
      <StyledInfoLabel key={1}>Edit Transaction</StyledInfoLabel>
      <StyledInfoContent>
        <StyledInfoDetail>
          <Formik
            initialValues={{
              name: initialData?.name || "",
              iconId: Object.entries(DefaultCategory)[0][0],
            }}
            // validate form values
            validationSchema={Yup.object({
              name: Yup.string()
                .required("Category name is required")
                .max(20, "Category name cannot exceed 20 characters"),
            })}
            // handle submit form
            onSubmit={handleSubmitForm}
            innerRef={formRef}
          >
            {({ values, errors, touched, handleChange, handleBlur, dirty }) => (
              <Form>
                <IconInput
                  onChange={handleChange}
                  name={"iconId"}
                  id={"iconId"}
                  value={values.iconId}
                />

                <FormItem
                  label={"Name"}
                  htmlFor="name"
                  hasError={!!(errors.name && touched.name)}
                  error={errors.name}
                  required
                  formItem={
                    <StyledFormInput
                      name={"name"}
                      id={"name"}
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder={"Enter wallet name"}
                      variant={"standard"}
                    />
                  }
                />
                <If condition={dirty}>
                  <StyledUnsaved>Your form has unsaved fields!</StyledUnsaved>
                </If>
                <StyledFormAction>
                  <WarningButton
                    onClick={() => handleCancelForm(formRef, onCancel)}
                  >
                    Cancel
                  </WarningButton>
                  <Button type={"submit"} variant={"contained"}>
                    Save
                  </Button>
                </StyledFormAction>
              </Form>
            )}
          </Formik>
        </StyledInfoDetail>
      </StyledInfoContent>
    </StyledInfoWrapper>
  );
};

export default CategoryEdit;
